export default __webpack_public_path__ + "static/media/IMG_0362-2.759274c6.jpg";